// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type IrrevocableTrustTaxStatusFragment = { __typename?: 'IrrevocableTrust', id: string, taxStatus?: Types.TrustTaxStatus | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null };

export type RevocableTrustTaxStatusFragment = { __typename?: 'RevocableTrust', id: string, taxStatus?: Types.TrustTaxStatus | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null };

export type SlatTrustTaxStatusFragment = { __typename?: 'SLATTrust', id: string, taxStatus?: Types.TrustTaxStatus | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null };

export type IlitTrustTaxStatusFragment = { __typename?: 'ILITTrust', id: string, taxStatus?: Types.TrustTaxStatus | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null };

export type GratTrustTaxStatusFragment = { __typename?: 'GRATTrust', id: string, taxStatus?: Types.TrustTaxStatus | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null };

export type QprtTrustTaxStatusFragment = { __typename?: 'QPRTTrust', id: string, taxStatus?: Types.TrustTaxStatus | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null };

export type CltTrustTaxStatusFragment = { __typename?: 'CLTTrust', id: string, taxStatus?: Types.TrustTaxStatus | null, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null };

export type QualifiedTuitionNonTrustEntityTaxStatusFragment = { __typename?: 'QualifiedTuitionPersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus };

export type CustodialNonTrustEntityTaxStatusFragment = { __typename?: 'CustodialPersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus };

export type IndividualNonTrustEntityTaxStatusFragment = { __typename?: 'IndividualPersonalAccount', id: string, inclusionRatio?: GraphQLDecimal | null, nonTrustEntityTaxStatusOptional?: Types.NonTrustEntityTaxStatus | null };

export type DonorAdvisedFundEntityTaxStatusFragment = { __typename?: 'DonorAdvisedFund', id: string, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus };

export type PrivateFoundationEntityTaxStatusFragment = { __typename?: 'PrivateFoundation', id: string, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus };

export type PersonalAccountTaxStatus_CustodialPersonalAccount_Fragment = { __typename?: 'CustodialPersonalAccount', inclusionRatio?: GraphQLDecimal | null, id: string, gstStatus?: Types.EntityGstStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null };

export type PersonalAccountTaxStatus_IndividualPersonalAccount_Fragment = { __typename?: 'IndividualPersonalAccount', inclusionRatio?: GraphQLDecimal | null, id: string, gstStatus?: Types.EntityGstStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null };

export type PersonalAccountTaxStatus_InsurancePersonalAccount_Fragment = { __typename?: 'InsurancePersonalAccount', inclusionRatio?: GraphQLDecimal | null, id: string, gstStatus?: Types.EntityGstStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null };

export type PersonalAccountTaxStatus_JointPersonalAccount_Fragment = { __typename?: 'JointPersonalAccount', inclusionRatio?: GraphQLDecimal | null, id: string, gstStatus?: Types.EntityGstStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null };

export type PersonalAccountTaxStatus_QualifiedTuitionPersonalAccount_Fragment = { __typename?: 'QualifiedTuitionPersonalAccount', inclusionRatio?: GraphQLDecimal | null, id: string, gstStatus?: Types.EntityGstStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null };

export type PersonalAccountTaxStatus_RetirementPersonalAccount_Fragment = { __typename?: 'RetirementPersonalAccount', inclusionRatio?: GraphQLDecimal | null, id: string, gstStatus?: Types.EntityGstStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null };

export type PersonalAccountTaxStatusFragment = PersonalAccountTaxStatus_CustodialPersonalAccount_Fragment | PersonalAccountTaxStatus_IndividualPersonalAccount_Fragment | PersonalAccountTaxStatus_InsurancePersonalAccount_Fragment | PersonalAccountTaxStatus_JointPersonalAccount_Fragment | PersonalAccountTaxStatus_QualifiedTuitionPersonalAccount_Fragment | PersonalAccountTaxStatus_RetirementPersonalAccount_Fragment;

export type JointAccountTaxStatusFragment = { __typename?: 'JointPersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inclusionRatio?: GraphQLDecimal | null, nonTrustEntityTaxStatus?: Types.NonTrustEntityTaxStatus | null, nonTrustEntityInEstateStatus: Types.EntityInEstateStatus, nonTrustEntityStateInEstateStatus: Types.EntityInEstateStatus };

export type EntityTaxStatusFragment = { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity' } | (
    { __typename?: 'CLTTrust' }
    & CltTrustTaxStatusFragment
  ) | { __typename?: 'CRTTrust' } | (
    { __typename?: 'CustodialPersonalAccount' }
    & CustodialNonTrustEntityTaxStatusFragment
    & PersonalAccountTaxStatus_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & DonorAdvisedFundEntityTaxStatusFragment
  ) | { __typename?: 'GPBusinessEntity' } | (
    { __typename?: 'GRATTrust' }
    & GratTrustTaxStatusFragment
  ) | (
    { __typename?: 'ILITTrust' }
    & IlitTrustTaxStatusFragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & IndividualNonTrustEntityTaxStatusFragment
    & PersonalAccountTaxStatus_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & PersonalAccountTaxStatus_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & IrrevocableTrustTaxStatusFragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & PersonalAccountTaxStatus_JointPersonalAccount_Fragment
    & JointAccountTaxStatusFragment
  ) | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | (
    { __typename?: 'PrivateFoundation' }
    & PrivateFoundationEntityTaxStatusFragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & QprtTrustTaxStatusFragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & QualifiedTuitionNonTrustEntityTaxStatusFragment
    & PersonalAccountTaxStatus_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & PersonalAccountTaxStatus_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & RevocableTrustTaxStatusFragment
  ) | { __typename?: 'SCorpBusinessEntity' } | (
    { __typename?: 'SLATTrust' }
    & SlatTrustTaxStatusFragment
  ) | { __typename?: 'SoleProprietorshipBusinessEntity' } };

export const Operations = {
  Fragment: {
    IrrevocableTrustTaxStatus: 'IrrevocableTrustTaxStatus' as const,
    RevocableTrustTaxStatus: 'RevocableTrustTaxStatus' as const,
    SLATTrustTaxStatus: 'SLATTrustTaxStatus' as const,
    ILITTrustTaxStatus: 'ILITTrustTaxStatus' as const,
    GRATTrustTaxStatus: 'GRATTrustTaxStatus' as const,
    QPRTTrustTaxStatus: 'QPRTTrustTaxStatus' as const,
    CLTTrustTaxStatus: 'CLTTrustTaxStatus' as const,
    QualifiedTuitionNonTrustEntityTaxStatus: 'QualifiedTuitionNonTrustEntityTaxStatus' as const,
    CustodialNonTrustEntityTaxStatus: 'CustodialNonTrustEntityTaxStatus' as const,
    IndividualNonTrustEntityTaxStatus: 'IndividualNonTrustEntityTaxStatus' as const,
    DonorAdvisedFundEntityTaxStatus: 'DonorAdvisedFundEntityTaxStatus' as const,
    PrivateFoundationEntityTaxStatus: 'PrivateFoundationEntityTaxStatus' as const,
    PersonalAccountTaxStatus: 'PersonalAccountTaxStatus' as const,
    JointAccountTaxStatus: 'JointAccountTaxStatus' as const,
    EntityTaxStatus: 'EntityTaxStatus' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const IrrevocableTrustTaxStatusFragmentDoc = gql`
    fragment IrrevocableTrustTaxStatus on IrrevocableTrust {
  id
  taxStatus
  inEstateStatus
  stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const RevocableTrustTaxStatusFragmentDoc = gql`
    fragment RevocableTrustTaxStatus on RevocableTrust {
  id
  taxStatus
  inEstateStatus
  stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const SlatTrustTaxStatusFragmentDoc = gql`
    fragment SLATTrustTaxStatus on SLATTrust {
  id
  taxStatus
  inEstateStatus
  stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const GratTrustTaxStatusFragmentDoc = gql`
    fragment GRATTrustTaxStatus on GRATTrust {
  id
  taxStatus
  inEstateStatus
  stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const IlitTrustTaxStatusFragmentDoc = gql`
    fragment ILITTrustTaxStatus on ILITTrust {
  id
  taxStatus
  inEstateStatus
  stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const QprtTrustTaxStatusFragmentDoc = gql`
    fragment QPRTTrustTaxStatus on QPRTTrust {
  id
  taxStatus
  inEstateStatus
  stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const CltTrustTaxStatusFragmentDoc = gql`
    fragment CLTTrustTaxStatus on CLTTrust {
  id
  taxStatus
  inEstateStatus
  stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const QualifiedTuitionNonTrustEntityTaxStatusFragmentDoc = gql`
    fragment QualifiedTuitionNonTrustEntityTaxStatus on QualifiedTuitionPersonalAccount {
  id
  nonTrustEntityTaxStatus: taxStatus
  nonTrustEntityInEstateStatus: inEstateStatus
  nonTrustEntityStateInEstateStatus: stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const CustodialNonTrustEntityTaxStatusFragmentDoc = gql`
    fragment CustodialNonTrustEntityTaxStatus on CustodialPersonalAccount {
  id
  nonTrustEntityTaxStatus: taxStatus
  nonTrustEntityInEstateStatus: inEstateStatus
  nonTrustEntityStateInEstateStatus: stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const DonorAdvisedFundEntityTaxStatusFragmentDoc = gql`
    fragment DonorAdvisedFundEntityTaxStatus on DonorAdvisedFund {
  id
  nonTrustEntityTaxStatus: taxStatus
  nonTrustEntityInEstateStatus: inEstateStatus
  nonTrustEntityStateInEstateStatus: stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const PrivateFoundationEntityTaxStatusFragmentDoc = gql`
    fragment PrivateFoundationEntityTaxStatus on PrivateFoundation {
  id
  nonTrustEntityTaxStatus: taxStatus
  nonTrustEntityInEstateStatus: inEstateStatus
  nonTrustEntityStateInEstateStatus: stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const IndividualNonTrustEntityTaxStatusFragmentDoc = gql`
    fragment IndividualNonTrustEntityTaxStatus on IndividualPersonalAccount {
  id
  nonTrustEntityTaxStatusOptional: taxStatus
  inclusionRatio
}
    `;
export const PersonalAccountTaxStatusFragmentDoc = gql`
    fragment PersonalAccountTaxStatus on PersonalAccount {
  id
  nonTrustEntityTaxStatus: taxStatus
  gstStatus
  ... on CustodialPersonalAccount {
    inclusionRatio
    nonTrustEntityInEstateStatus: inEstateStatus
    nonTrustEntityStateInEstateStatus: stateInEstateStatus
  }
  ... on IndividualPersonalAccount {
    inclusionRatio
    nonTrustEntityInEstateStatus: inEstateStatus
    nonTrustEntityStateInEstateStatus: stateInEstateStatus
  }
  ... on QualifiedTuitionPersonalAccount {
    inclusionRatio
    nonTrustEntityInEstateStatus: inEstateStatus
    nonTrustEntityStateInEstateStatus: stateInEstateStatus
  }
  ... on InsurancePersonalAccount {
    inclusionRatio
    nonTrustEntityInEstateStatus: inEstateStatus
    nonTrustEntityStateInEstateStatus: stateInEstateStatus
  }
  ... on JointPersonalAccount {
    inclusionRatio
    nonTrustEntityInEstateStatus: inEstateStatus
    nonTrustEntityStateInEstateStatus: stateInEstateStatus
  }
  ... on RetirementPersonalAccount {
    inclusionRatio
    nonTrustEntityInEstateStatus: inEstateStatus
    nonTrustEntityStateInEstateStatus: stateInEstateStatus
  }
}
    `;
export const JointAccountTaxStatusFragmentDoc = gql`
    fragment JointAccountTaxStatus on JointPersonalAccount {
  id
  nonTrustEntityTaxStatus: taxStatus
  nonTrustEntityInEstateStatus: inEstateStatus
  nonTrustEntityStateInEstateStatus: stateInEstateStatus
  gstStatus
  inclusionRatio
}
    `;
export const EntityTaxStatusFragmentDoc = gql`
    fragment EntityTaxStatus on Entity {
  id
  subtype {
    ...IrrevocableTrustTaxStatus
    ...RevocableTrustTaxStatus
    ...SLATTrustTaxStatus
    ...GRATTrustTaxStatus
    ...ILITTrustTaxStatus
    ...QPRTTrustTaxStatus
    ...CLTTrustTaxStatus
    ...QualifiedTuitionNonTrustEntityTaxStatus
    ...CustodialNonTrustEntityTaxStatus
    ...DonorAdvisedFundEntityTaxStatus
    ...PrivateFoundationEntityTaxStatus
    ...IndividualNonTrustEntityTaxStatus
    ...PersonalAccountTaxStatus
    ...JointAccountTaxStatus
  }
}
    ${IrrevocableTrustTaxStatusFragmentDoc}
${RevocableTrustTaxStatusFragmentDoc}
${SlatTrustTaxStatusFragmentDoc}
${GratTrustTaxStatusFragmentDoc}
${IlitTrustTaxStatusFragmentDoc}
${QprtTrustTaxStatusFragmentDoc}
${CltTrustTaxStatusFragmentDoc}
${QualifiedTuitionNonTrustEntityTaxStatusFragmentDoc}
${CustodialNonTrustEntityTaxStatusFragmentDoc}
${DonorAdvisedFundEntityTaxStatusFragmentDoc}
${PrivateFoundationEntityTaxStatusFragmentDoc}
${IndividualNonTrustEntityTaxStatusFragmentDoc}
${PersonalAccountTaxStatusFragmentDoc}
${JointAccountTaxStatusFragmentDoc}`;